'use client'
import { InputNumber } from '@repo/ui/components'
import { useRef } from 'react'

export interface TransferAmountInputProps {
  name: string
  value: number
  onChange: (value: number) => void
  assetLabel?: string
  onAmountChange?: (value: number) => void
  disabled?: boolean
}

export const TransferAmountInput = ({
  name,
  value,
  onChange,
  assetLabel,
  onAmountChange,
  disabled = false,
}: TransferAmountInputProps) => {
  const timeout = useRef<NodeJS.Timeout | null>(null)

  return (
    <InputNumber
      name={name}
      min={0}
      // max={max}
      endLabel={assetLabel}
      inputSize='md'
      itemType='number'
      value={value}
      thousandSeparator={true}
      onValueChange={(e) => {
        onChange(e.floatValue ?? 0)

        if (timeout.current) {
          clearTimeout(timeout.current)
        }

        timeout.current = setTimeout(() => {
          onAmountChange?.(e.floatValue ?? 0)
        }, 1000)
      }}
      disabled={disabled}
    />
  )
}
